<template>
    <div class="text-center mt-5">
        <h2 class="mt-5 mb-5">Welcome to {{site_name}}</h2>
        <h6 class="mb-10" v-if="frontend == 'frontend.skjersaas'">Thank you for choosing {{site_name}}, Oregon's Oldest ski and snowboard shop for your rental needs.</h6>
        <h6 class="mb-10" v-else>Thank you for choosing {{site_name}} ski and snowboard shop for your rental needs.</h6>
        <h5 class="mt-5 mb-5">Ready to rent skis and snowboards?</h5>
        <div>
            <v-btn
                color="primary"
                @click="inShop"
                v-if="!is_delivery"
            >
                In Shop
            </v-btn>
            <v-btn
                color="primary"
                v-else-if="delivery"
                @click="deliveryPage"
            >
                Delivery
            </v-btn>
        </div>
    </div>
</template>

<script>
import {mapActions} from "vuex";
import StepperComponentMixin from "../../../mixins/StepperComponentMixin";

export default {
    name: "StepDeliveryPage",
    mixins: [StepperComponentMixin],
    methods   : {
        async deliveryPage() {
            this.$store.commit('set_model_value',{path:'model.reservation.is_delivery', value: 1})
            await this.moveToStep(2);
        },
        async inShop(){
            await this.moveToStep(2);
        }
    },
    computed  : {
        delivery(){
            return this.$store.state.resources.config.delivery==='1';
        },
        site_name(){
            return this.$store.state.resources.config.site_name;
        },
        is_delivery(){
            let status = false;
            console.log('Host name - ',window.location.hostname);
            if(window.location.href.includes('delivery') && window.location.hostname!="delivery.winterparkskirental.com"){
                status = true;
            }
            return status;
        }
    }
}
</script>

<style scoped>

</style>
